import React, {useContext, useEffect, useState} from "react";
import Box from '@mui/material/Box';
import {DataGrid, GridToolbarContainer, GridToolbarFilterButton, GridLinkOperator, GridToolbar} from '@mui/x-data-grid';
import {getLastOnline} from "../firebase";
import {getAge, isObjectEmpty, toDateTime} from "../utils/utils";
import Tooltip from "@material-ui/core/Tooltip";
import {Loader} from "../components/loader";
import {useDispatch, useSelector} from "react-redux";
import {getUsers} from "../ducks/user";
import { useNavigate } from "react-router-dom";

const CustomToolbar = ({setFilterButtonEl}) => (
    <GridToolbarContainer>
        <GridToolbarFilterButton ref={setFilterButtonEl}/>
    </GridToolbarContainer>
);

export function Users() {

    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const users = useSelector((state) => state.user.users);

    const columns = [
        {
            field: 'profileImage',
            headerName: '',
            width: 45,
            filterable: false,
            sortable: false,
            editable: false,
            disableColumnMenu: true,
            align: 'center',
            renderCell: (params) => {
                if (params?.value) {
                    return (
                        <img
                            onClick={() => {
                                console.log('cell click', users[params.id])
                                // console.log('users', users)
                                let userInfo = users.find(x => x.id == params.id)
                                console.log('userInfo', userInfo)

                                navigate(`/user-detail/${params.id}`, { state: {...userInfo}});
                            }}
                            style={{height: 40, width: 40, borderRadius: 20}}
                            src={params?.value}
                            alt="profile image"
                        />
                    );
                } else {
                    return null;
                }
            },
        },
        {
            field: 'id',
            headerName: 'ID',
            width: 280,
        },
        {
            field: 'fullName',
            headerName: 'Full Name',
            width: 160,
            valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
            renderCell: (params) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 180,
        },
        {
            field: 'lastOnline',
            headerName: 'Last Online',
            width: 180,
        },
        {
            field: 'age',
            headerName: 'Age',
            width: 30,
        },
        {
            field: 'gender',
            headerName: 'Gender',
            width: 100,
        },
        {
            field: 'city',
            headerName: 'City',
            width: 120,
        },
        {
            field: 'state',
            headerName: 'State',
            width: 40,
        },
        {
            field: 'address',
            headerName: 'Address',
            width: 400,
            renderCell: (params) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'mainCourt',
            headerName: 'Main Court',
            width: 200,
            renderCell: (params) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'mainCourtAddress',
            headerName: 'Main Court Address',
            width: 400,
            renderCell: (params) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'ustaRating',
            headerName: 'USTA Rating',
            width: 100,
        },

    ];

    useEffect(() => {
        const getData = async () => {
            if (users.length == 0) {
                setIsLoading(true);

                dispatch(getUsers());
            }
        };

        getData();
    }, [dispatch]);

    useEffect(() => {
        const getData = async () => {

            if (users.length == 0) {
                return;
            }

            console.log('Users useEffect')
            let lastOnline = await getLastOnline();

            console.log('lastOnline', lastOnline)
            let rowData = [];
            for (const [userId, userData] of Object.entries(users)) {
                let row = {
                    id: userData.id,
                    profileImage: userData.profileImages?.[0],
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    email: userData.email,
                    lastOnline: userData.id in lastOnline ? toDateTime(lastOnline[userData.id], 'YYYY/MM/DD HH:mm:ss') : null,
                    age: getAge(userData.dob),
                    gender: userData.gender,
                    ustaRating: userData.ustaRating,
                    city: userData.addressInfo?.locality ? userData?.addressInfo?.locality : userData?.addressInfo?.city,
                    state: userData.addressInfo?.state,
                    address: userData.addressInfo?.address,
                    mainCourt: userData.clubCourts?.[0]?.name,
                    mainCourtAddress: userData.clubCourts?.[0]?.address,
                };

                rowData.push(row);
            }


            setRows(rowData);
            console.log('Users rowData', rowData)
            setIsLoading(false);
        };

        getData();
    }, [users]);

    if (isLoading) {
        return (<Loader/>);
    }

    return (
        <Box height="100vh" display="flex" flexDirection="column">
            <DataGrid
                sx={{
                    boxShadow: 2,
                    '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                    },
                }}
                initialState={{
                    sorting: {
                        sortModel: [{field: 'lastOnline', sort: 'desc'}],
                    },
                }}
                componentsProps={{
                    filterPanel: {
                        // Force usage of "And" operator
                        linkOperators: [GridLinkOperator.And],
                        // Display columns by ascending alphabetical order
                        columnsSort: 'asc',
                        filterFormProps: {
                            // Customize inputs by passing props
                            linkOperatorInputProps: {
                                variant: 'outlined',
                                size: 'small',
                            },
                            columnInputProps: {
                                variant: 'outlined',
                                size: 'small',
                                sx: {mt: 'auto'},
                            },
                            operatorInputProps: {
                                variant: 'outlined',
                                size: 'small',
                                sx: {mt: 'auto'},
                            },
                            valueInputProps: {
                                InputComponentProps: {
                                    variant: 'outlined',
                                    size: 'small',
                                },
                            },
                            deleteIconProps: {
                                sx: {
                                    '& .MuiSvgIcon-root': {color: '#d32f2f'},
                                },
                            },
                        },
                        sx: {
                            // Customize inputs using css selectors
                            '& .MuiDataGrid-filterForm': {p: 2},
                            '& .MuiDataGrid-filterForm:nth-child(even)': {
                                backgroundColor: (theme) =>
                                    theme.palette.mode === 'dark' ? '#444' : '#f5f5f5',
                            },
                            '& .MuiDataGrid-filterFormLinkOperatorInput': {mr: 2},
                            '& .MuiDataGrid-filterFormColumnInput': {mr: 2, width: 150},
                            '& .MuiDataGrid-filterFormOperatorInput': {mr: 2},
                            '& .MuiDataGrid-filterFormValueInput': {width: 200},
                        },
                    },
                }}
                components={{
                    Toolbar: GridToolbar,
                }}
                // components={{
                //     Toolbar: CustomToolbar,
                // }}
                rows={rows}
                columns={columns}
                pageSize={50}
                rowsPerPageOptions={[5]}
                checkboxSelection
                disableSelectionOnClick
                experimentalFeatures={{newEditingApi: true}}
            />
        </Box>
    );
}
